import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  ImageField,
  BooleanField,
  NumberField,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { useBackendTranslate } from '../../hooks/settings/useBackendTranslation';

const filters = [<SearchInput source='name' alwaysOn />];

export default function ResourceList(props: any) {
  const getTranslation = useBackendTranslate();
  const t = useTranslate();

  return (
    <List {...props} filters={filters}>
      <Datagrid rowClick='edit'>
        <NumberField source='id' />
        <ImageField source={'image'} />
        <FunctionField
          label={t('ra.categories.name')}
          render={(record: any) => `${getTranslation(record, 'name')}`}
        />
        <TextField source='slug' />
        <TextField source='parent' />
        <BooleanField source='isActive' />
      </Datagrid>
    </List>
  );
}
